import { formatURIComponent } from "./utils"

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=hotelGroupTourismDestination&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '',
        pageTitle: '酒店群旅游度假目的地',
        pageTitleIcon: '',
        background_img: '',
        description: `华美专注于酒店群旅游度假目的地的整体开发与运营优化，面对当前市场常见的业态单一、资源联动不足、季节性经营波动大等痛点问题，提供从选址规划、产品策划到一体化运营的全链条服务。通过精准客群分析构建差异化产品矩阵，植入在地文化元素串联景区资源，确保各业态互补共生形成消费闭环。`,
        icons: [
            {
                name: '目的地',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/18.目的地.pdf'),
                path: "四库赋能-酒店+/酒店群旅游度假目的地/目的地"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店+/酒店群旅游度假目的地/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店plus/酒店群旅游度假目的地/数据赋能'),
                path: "四库赋能-酒店+/酒店群旅游度假目的地/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/酒店群旅游度假目的地/全球案例/全球案例（酒店群旅游度假目的地）.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/酒店群旅游度假目的地/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                url: makeUrl('/内容文件/四库赋能-酒店plus/酒店群旅游度假目的地/预警问题/预警问题（酒店群旅游度假目的地）.xlsx'),
                background: 'black',
                path: "四库赋能-酒店+/酒店群旅游度假目的地/预警问题"
            }
        ]
    }]
}